import { useState } from "react";

import loadingGreen from "../../images/loading_gray.gif";
import { FILE_FORMATS, HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { uploadFileToS3 } from "../../utils/s3Upload";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import FileUploadInput from "../FileUploadInput/FileUploadInput";
import Modal from "../Modal/Modal";
import { Container, Input, MainButton } from "./FileUploadSenasaModalStyles";

function FileUploadSenasaModal(props) {
  const {
    damNum,
    updateSenasaStatus,
    refreshBilling,
    getSenasaAndElectronicMandate,
  } = props;
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [inputDischarge, updateInputDischarge] = useState("");
  const [checkedDischarge, updateCheckedDischarge] = useState(false);
  const [waitingServerResponse, updateWaitingServerResponse] = useState(false);
  const [showConfirmationModal, updateShowConfirmationModal] = useState(false);

  const onFileChange = (files) => {
    setSelectedFiles(files);
  };

  const onFileUpload = () => {
    if (waitingServerResponse) return;

    updateWaitingServerResponse(true);
    uploadFileToS3("senasa", selectedFiles, "acta_senasa_")
      .then((urlFiles) => updateDam(damNum, inputDischarge, urlFiles))
      .then((damData) => {
        if (updateSenasaStatus) {
          updateSenasaStatus(damData.senasa_status);
        }
        updateWaitingServerResponse(false);
        setSelectedFiles([]);
        updateInputDischarge("");
        updateCheckedDischarge(false);
        toggleConfirmationModal();
      })
      .catch(() => updateWaitingServerResponse(false));
  };

  const onCancel = () => {
    props.hideModal();
  };

  const handleDischargeInput = (e) => {
    if (checkedDischarge) updateInputDischarge("");
    updateCheckedDischarge(e.target.checked);
  };

  const toggleConfirmationModal = () => {
    updateShowConfirmationModal(!showConfirmationModal);
  };

  return showConfirmationModal ? (
    <ConfirmationModal
      title={
        selectedFiles.length > 1
          ? "Documentos subidos con éxito"
          : "Documento subido con éxito"
      }
      message={
        (selectedFiles.length > 1
          ? "La carga de los documentos ha sido exitosa."
          : "La carga del documento ha sido exitosa.") +
        " Haga clic en entendido o cierre el diálogo para continuar."
      }
      toggleModal={() => {
        onCancel();
        toggleConfirmationModal();
        if (refreshBilling) {
          refreshBilling();
        }
        if (getSenasaAndElectronicMandate) {
          getSenasaAndElectronicMandate.retry();
        }
      }}
      onAccept={() => {
        onCancel();
        toggleConfirmationModal();
        if (refreshBilling) {
          refreshBilling();
        }
        if (getSenasaAndElectronicMandate) {
          getSenasaAndElectronicMandate.retry();
        }
      }}
    />
  ) : (
    <Modal onOutsideClick={onCancel}>
      <Container>
        <h1>Adjuntar Acta de SENASA</h1>
        <FileUploadInput
          maxFiles={3}
          onValueChange={onFileChange}
          value={selectedFiles}
          formats={[FILE_FORMATS.IMAGE, FILE_FORMATS.PDF]}
          disabled={waitingServerResponse}
        />
        <label className="discharge-div">
          <input
            type="checkbox"
            checked={checkedDischarge}
            onChange={(e) => handleDischargeInput(e)}
            disabled={waitingServerResponse}
          />
          Descargo
        </label>
        <div className="message-discharge">
          <Input
            type="text"
            placeholder={"Escriba el descargo"}
            disabled={!checkedDischarge || waitingServerResponse}
            onChange={(e) => {
              updateInputDischarge(e.target.value);
            }}
            value={inputDischarge}
          />
        </div>
        <MainButton
          disabled={selectedFiles.length === 0 || waitingServerResponse}
          onClick={onFileUpload}
        >
          {waitingServerResponse && (
            <img
              src={loadingGreen}
              width="50"
              height="50"
              alt="Processing request"
            />
          )}
          Enviar Documento
        </MainButton>
      </Container>
    </Modal>
  );
}
export default FileUploadSenasaModal;

function updateDam(damNum, dischargeComment, urlFiles) {
  return networkBackendRequest(
    `/dams/senasa-agent/${damNum}/`,
    HTTP_METHODS.PATCH,
    {},
    {
      senasa_status_option: "reviewing",
      senasa_docs: {
        object_keys: urlFiles,
      },
      senasa_comment: dischargeComment,
    }
  ).then((response) => response.json());
}
